module.exports = __webpack_public_path__ + "media/images/icons/outlined/usergroup-delete-2495d92d4e14b21cc40dad75a38fdf39.svg";